package com.karawek.core.auth.model

sealed interface AuthMethod

/** Platform passkey / WebAuthn credential. */
data object Passkey : AuthMethod

enum class OtpChannel: AuthMethod {
    Email,
    Phone,
    WhatsApp,
}

enum class NativeProvider: AuthMethod {
    Google,
    Apple,
}

enum class OAuthProvider: AuthMethod {
    Google,
    Apple,
    Facebook,
}
